import React from "react";
import { NavLink } from "react-router-dom";
import {
  FaCalendarCheck,
  FaSms,
  FaEnvelope,
  FaPhone,
  FaWalking,
  FaSave,
  FaStar,
  FaListAlt,
} from "react-icons/fa";

import AccordionView from "../../components/accordion/accordion";
import {
  formatActivityDate,
  get5WordsForTitle,
  getIconByEvent,
  phoneDisplay,
} from "../../utils/helpers";
import routeConstants from "../layout/routes";
import {
  formatActivityFeedCommunities,
  formatActivityFeedUserName,
  getActivityFeedCardStyle,
  getActivityFeedCategory,
  getActivityFeedIconTitle,
} from "./activity-feed-list-utils";
import "../common-lead-prospect-details/style.css";

const DETAIL_ROUTE_BY_TYPE = {
  Lead: routeConstants.LEAD_DETAIL,
  Prospect: routeConstants.PROSPECT_DETAIL,
  Marketing_Only: routeConstants.MARKETING_ONLY_DETAIL,
};

const DETAIL_ID_FIELD_BY_TYPE = {
  Lead: "lead_id",
  Prospect: "prospect_id",
  Marketing_Only: "marketing_only_id",
};

const FALLBACK_ICON_BY_CATEGORY = {
  Phone: FaPhone,
  Text: FaSms,
  Email: FaEnvelope,
  Appointment: FaCalendarCheck,
  "Web Form": FaListAlt,
  Traffic: FaWalking,
  "Saved Floor Plan": FaSave,
  "Favorite Floor Plan": FaStar,
  Default: FaEnvelope,
};

const ActivityFeedIcon = ({ activityType }) => {
  const iconTitle = getActivityFeedIconTitle(activityType);
  const fromHelpers = iconTitle ? getIconByEvent(iconTitle) : null;
  if (fromHelpers) return fromHelpers;

  const category = getActivityFeedCategory(activityType);
  const Icon = FALLBACK_ICON_BY_CATEGORY[category] || FaEnvelope;
  return <Icon size={11} style={{ marginRight: "4px" }} />;
};

const CustomerNameLink = ({ item, customerType }) => {
  const idField = DETAIL_ID_FIELD_BY_TYPE[customerType];
  const detailId = idField ? item[idField] : null;
  const pathname = DETAIL_ROUTE_BY_TYPE[customerType];
  const label = item.customer_name || "———";

  if (!detailId || !pathname) return <span>{label}</span>;

  return (
    <NavLink
      to={{ pathname: `${pathname}/${detailId}`, id: detailId }}
      onClick={(e) => e.stopPropagation()}
    >
      {label}
    </NavLink>
  );
};

/**
 * Accordion body for a single Activity Report row (Past Activities–style).
 */
const ActivityFeedListItemContent = ({ pastActivitiesData, customerType, render }) => {
  const item = pastActivitiesData;

  const toggle = (activity) => {
    const titleText = activity.activity_title
      ? get5WordsForTitle(activity.activity_title)
      : null;

    return (
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center flex-wrap">
          <div
            className="d-flex align-items-center"
            style={{ marginRight: "2px" }}
          >
            <ActivityFeedIcon activityType={activity.activity_type} />
            <span style={{ fontSize: "12px" }}>
              {activity.activity_type || "Activity"}:
            </span>
          </div>
          {titleText}
          <span className="activity-feed-toggle-customer ml-2">
            {" - "}
            <CustomerNameLink item={activity} customerType={customerType} />
          </span>
        </div>
        <div className="d-flex align-items-center toggle-date-time">
          {formatActivityDate(activity.activity_datetime)}
        </div>
      </div>
    );
  };


  const collapse = (activity) => (
      <ul className="noted-descr-body">
        
        {activity.activity_title && (
          <li>
            <label>TITLE:</label>
            <span>{activity.activity_title}</span>
          </li>
        )}
        <li>
          <label>CUSTOMER:</label>
          <span>
            <CustomerNameLink item={activity} customerType={customerType} />
          </span>
        </li>
        <li>
          <label>EMAIL:</label>
          <span>{activity.customer_email || "———"}</span>
        </li>
        <li>
          <label>PHONE:</label>
          <span>{phoneDisplay(activity.customer_phone) || "———"}</span>
        </li>
        <li>
          <label>USER:</label>
          <span>{formatActivityFeedUserName(activity.csm)}</span>
        </li>
        <li>
          <label>COMMUNITY:</label>
          <span>{formatActivityFeedCommunities(activity.communities)}</span>
        </li>
        {(activity.activity_type || "").includes("Appointment") && (
          <li>
            <label>APPOINTMENT TYPE:</label>
            <span>{activity.appointment_type || "———"}</span>
          </li>
        )}
        <li>
          <label>SOURCE:</label>
          <span>
            {activity.customer_origination_area?.name || "———"}
          </span>
        </li>
        <li>
          <label>TRAFFIC:</label>
          <span>{activity.is_traffic_activity ? "Yes" : "No"}</span>
        </li>
      </ul>
  );

  return (
    <div className="notes-card">
      {render(toggle(item), collapse(item))}
    </div>
  );
};

/**
 * Single Activity Feed accordion card — visual match to Past Activities rows.
 */
const ActivityFeedListItem = ({ item, customerType }) => (
  <AccordionView
    component={ActivityFeedListItemContent}
    pastActivitiesData={item}
    customerType={customerType}
    style={getActivityFeedCardStyle(item.activity_type)}
  />
);

export default ActivityFeedListItem;
